import React, { useCallback, useEffect, useState } from 'react';
import { SimpleGrid, Text } from '@chakra-ui/react';
import { search } from 'ss-search';
import Quagga from '@ericblade/quagga2';

import api from '../../services/api';
import { useAuth } from '../../hooks/auth';
import { useCart } from '../../hooks/cart';
import { formatPrice } from '../../utils/format';
import useDebounce from '../../utils/useDebounce';
import Loading from '../../components/Loading';
import Cart from '../../components/Cart';
import MenuClassifs from '../../components/ComponentsProducao/MenuClassifs';
import ModalProdutoItem from '../../components/ComponentsProducao/ModalProdutoItem';
import ProdutoItem from '../../components/ComponentsProducao/ProdutoItem';
import Sidebar from '../../components/Sidebar';
import ModalScanner from '../../components/ComponentsProducao/ModalScanner';
import ModalTrocaLoja from '../../components/ComponentsProducao/ModalTrocaLoja';

import { Container, Content, ClassifTitle } from './styles';

type LojaData = {
	id: string;
	nome: string;
	url_avatar: string;
	url_page: string;
	fantazia: string;
	fone: string;
	endereco: {
		cep: string;
		uf: string;
		cid: string;
		cidcod: string;
		bai: string;
		endereco: string;
		num: string;
		comp: string;
		formatted_address: string;
		location: {
			lat: number;
			lng: number;
		};
	};
}
type ProdutoData = {
	id: string;
	categoria: string;
	cod_barras: string;
	cod_pro: string;
	comiss_ind: number;
	comiss_ven: number;
	complementos: ComplementoData[];
	descricao: string;
	nome: string;
	obs: string;
	promocao: string;
	qtd: number;
	url_imagem: string;
	valor: number;
	valorFormatted: string;
	total: number;
	totalFormatted: string;
}
type ComplementoData = {
	codigo: number;
	grupo: number;
	nome: string;
	descricao: string;
	custo: number;
	valor: number;
	priceFormatted: string;
	qtd_maxima: number;
	qtd_gratis: number;
	qtd: number;
}
type ClassificacaoData = {
	CODCLA: number;
	CODSCL: number;
	nome: string;
}

const Producao: React.FC = () => {
	const { company } = useAuth();
	const { addCartMerchant } = useCart();

	const [loading, setLoading] = useState(true);

	const [produtos, setProdutos] = useState<ProdutoData[]>([]);
	const [searchProducts, setSearchProducts] = useState<ProdutoData[]>([]);
	const [classifs, setClassifs] = useState<ClassificacaoData[]>([]);

	const [isOpenCart, setIsOpenCart] = useState(false);
	const [selectedClassif, setSelectedClassif] = useState<ClassificacaoData>({} as ClassificacaoData);

	const [isOpenModalItem, setIsOpenModalItem] = useState(false);
	const [produtoItemModal, setProdutoItemModal] = useState<ProdutoData>({} as ProdutoData);
	const [isAddNewItem, setIsAddNewItem] = useState(true);

	const [isOpenModalScanner, setIsOpenModalScanner] = useState(false);
	const [device, setDevice] = useState('');
	const [isVisibleBtnScanner, setIsVisibleBtnScanner] = useState(false);

	const [isOpenModalTrocaLoja, setIsOpenModalTrocaLoja] = useState(false);
	const [trocaLoja, setTrocaLoja] = useState<LojaData>({} as LojaData);

	useEffect(() => {
		setLoading(true);

		// setLoading(true);
		Quagga.CameraAccess.enumerateVideoDevices().then((devices) => {
			if (devices.length > 0) {
				setDevice(devices[devices.length - 1].deviceId);
				setIsVisibleBtnScanner(devices.length > 0);
			}
		});

		api.get('/controle/produto').then(response => {
			const aux = [] as ProdutoData[];

			if (response.data.itens && response.data.itens.length > 0) {
				const products = response.data.itens.map((product: ProdutoData) => {
					if (product.categoria === response.data.classificacao[0].nome) {
						aux.push(product);
					}

					return {
						...product,
						valorFormatted: formatPrice(product.valor),
						totalFormatted: formatPrice(product.total),
					}
				});
				setProdutos(products);
				setSearchProducts(aux);

				setClassifs(response.data.classificacao);
				setSelectedClassif(response.data.classificacao[0]);

				addCartMerchant(company.id);
			} else {
				setProdutos([]);
				setSearchProducts([]);
				setClassifs([]);
				setSelectedClassif({} as ClassificacaoData);
			}
		}). finally(() => {
			setLoading(false);
		})
	}, [company]);

	useEffect(() => {
		if (isOpenModalItem || isOpenModalScanner || isOpenCart) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'auto';
		}
	}, [
		isOpenModalItem,
		isOpenModalScanner,
		isOpenCart
	]);

	const handleSearchClassif = useCallback((event: string) => {
		const result = search(produtos, ['categoria'], event) as ProdutoData[];
		setSearchProducts(result);
	}, [produtos]);

	const handleSearchProduct = useCallback((text: string) => {
		if (text === '') {
			// handleSearchClassif(classifSelect.nome);
			return;
		}

		const searchKeysProduct = ['nome', 'descricao', 'categoria', 'cod_barras'];
		const resultsProducts = search(produtos, searchKeysProduct, text) as ProdutoData[];

		setSearchProducts(resultsProducts);
		setSelectedClassif({} as ClassificacaoData);
	},
		[produtos]
	);
	const debounceChange = useDebounce(handleSearchProduct, 1000);

	const handleCode = useCallback(async (code: string) => {
		const prod = produtos.find(product => product.cod_barras === code) as ProdutoData;

		if (prod) {
			setProdutoItemModal(prod);
			setIsAddNewItem(true);
			setIsOpenModalItem(true);
		}
	}, [produtos]);

	return (
		<Container>
			<Sidebar
				isOpenCart={setIsOpenCart}
				handleSearchProduct={debounceChange}
				setIsOpenScanner={setIsOpenModalScanner}
				isOpenScanner={isOpenModalScanner}
				isVisibleBtnScanner={isVisibleBtnScanner}
				setIsOpenModalTrocaLoja={setIsOpenModalTrocaLoja}
				setTrocaLoja={setTrocaLoja}
			/>

			{isOpenModalTrocaLoja && (
				<ModalTrocaLoja
					onRequestClose={setIsOpenModalTrocaLoja}
					selectLoja={trocaLoja}
				/>
			)}

			{loading ? (
				<Loading />
			) : (
				<Content>
					{classifs.length > 0 && (
						<MenuClassifs
							classifs={classifs}
							selectedClassif={selectedClassif}
							setSelectedClassif={setSelectedClassif}
							handleSearchClassif={handleSearchClassif}
						/>
					)}

					<ClassifTitle>
						<span>{selectedClassif.nome}</span>
					</ClassifTitle>

					{searchProducts.length > 0 ? (
						<SimpleGrid
							columns={[1, 1, 1, 2]}
							spacingX='6'
							spacingY='6'
							marginTop={2}
							justifyContent="center"
						>
							{searchProducts.map(produto => {
								return (
									<ProdutoItem
										key={produto.cod_barras}
										produto={produto}
										setIsNewItemModal={setIsOpenModalItem}
										setProdutoItemModal={setProdutoItemModal}
										setIsAddNewItem={setIsAddNewItem}
									/>
								)
							})}
						</SimpleGrid>
					) : (
						<Text fontSize={22}>Nenhum produto cadastrado..</Text>
					)}
				</Content>
			)}

			<Cart
				isOpen={isOpenCart}
				onRequestClose={setIsOpenCart}
			/>

			{isOpenModalItem && (
				<ModalProdutoItem
					isOpen={isOpenModalItem}
					onRequestClose={setIsOpenModalItem}
					produto={produtoItemModal}
					incluir={isAddNewItem}
				/>
			)}

			{isOpenModalScanner && (
				<ModalScanner
					onRequestClose={setIsOpenModalScanner}
					handleCode={handleCode}
					device={device}
				/>
			)}
		</Container>
	)
}

export default Producao;